import { motion } from "framer-motion";
import { Link as RouterLink, useParams } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Box, Button, Typography, Container } from "@mui/material";
// components
import { MotionContainer, varBounceIn } from "../components/animate";
import Page from "../components/Page";
import { useEffect, useState } from "react";
import * as constants from "src/utils/constants";
import apiInstance from "src/utils/apiAuth";

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
    display: "flex",
    minHeight: "100%",
    alignItems: "center",
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(10),
}));

// ----------------------------------------------------------------------

export default function MeetingVerification() {
    const { token } = useParams();
    const [title, setTitle] = useState("Verifying...");
    const [description, setDescription] = useState("Your access to the meeting is currently being verified. Sit tight and we'll get you in soon.");

    const getLinks = (token) => {
        let apiUrl = constants.HTTP_METHOD + constants.HTTP_URL + constants.HTTP_PORT + "/api/v1/interview-link/" + token + "/";
        apiInstance({
            method: "get",
            url: apiUrl,
        })
            .then((response) => {
                if (response) {
                    if (response.status === 200) {
                        if (response?.data?.url) window.location.href = response.data.url;
                        if (response?.data?.description) setDescription(response?.data?.description);
                        if (response?.data?.title) setTitle(response?.data?.title);
                    }
                }
            })
            .catch((error) => {
                if (error) {
                    let error_msg_key =
                        error?.response?.data && typeof error?.response?.data === "object"
                            ? Object.keys(error?.response?.data)?.[0]
                            : null;
                    let err_msg = error?.response?.data?.message || error?.response?.data?.[error_msg_key];
                    console.log(error?.customMessage || err_msg || "Something went wrong. Please try after sometime.")
                    setTitle("Sorry!");
                    setDescription("There was an error processing the meeting link.")
                }
            });
    };

    useEffect(() => {
        setTimeout(() => {getLinks(token)}, 2000)
    }, [])

    return (
        <RootStyle title="Gateway Meetings">
            <Container>
                <MotionContainer initial="initial" open>
                    <Box sx={{ maxWidth: 480, margin: "auto", textAlign: "center" }}>
                        <motion.div variants={varBounceIn}>
                            <Typography variant="h3" paragraph>
                                {title}
                            </Typography>
                        </motion.div>
                        <Typography sx={{ color: "text.secondary" }}>{description}</Typography>

                        <motion.div variants={varBounceIn}>
                            <Box
                                component="img"
                                src="/static/illustrations/virtual-meeting.png"
                                sx={{ height: "auto", mx: "auto", my: { xs: 5, sm: 5 } }}
                            />
                        </motion.div>

                        {/* <Button to="/" size="large" variant="contained" component={RouterLink}>
                            Login to CRM
                        </Button> */}
                    </Box>
                </MotionContainer>
            </Container>
        </RootStyle>
    );
}
